// extracted by mini-css-extract-plugin
export default {"cardWithBorder":"PaymentType_cardWithBorder__6Zwht","icon":"PaymentType_icon__y5JAN","title":"PaymentType_title__E-iAy"};